// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"1405573a","729":"c4ba7d6b"}[chunkId] + ".css";
};